
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/become-speaker",
      function () {
        return require("private-next-pages/become-speaker/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/become-speaker"])
      });
    }
  